export const MAX_ALLOWED_QUERIES = 7
